import { render, staticRenderFns } from "./edit-employee-notification-email-dialog.vue?vue&type=template&id=48f81c13&scoped=true&"
import script from "./edit-employee-notification-email-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-employee-notification-email-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f81c13",
  null
  
)

export default component.exports